go-gov-au-logo {
  --divider-color: var(--go-color-darkest);
  --divider-width: 1px;
  --divider-gap: 1rem;
  --link-color: currentColor;

  .logo-wrapper {
    text-decoration: none;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: var(--link-color);
    .main-brand {
      img {
        height: var(--logo-height, 3rem);
      }
    }
    .divider {
      width: var(--divider-width);
      height: auto;
      align-self: stretch;
      background-color: var(--divider-color);
      margin: 0 var(--divider-gap);
    }
  }
}
